import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      marginTop: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
